import {
  InlineTextInput,
  InlineTextInputProps,
  NextLabel,
} from '@cint/wonderment';
import { useController, useFormContext } from 'react-hook-form';

interface InlineTextInputFieldProps
  extends Omit<InlineTextInputProps, 'value' | 'onChange'> {
  name: string;
  label?: string;
}

export const InlineTextInputField = ({
  name,
  label,
  ...props
}: InlineTextInputFieldProps) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <div>
      {label && <NextLabel label={label} size="sm" isRequired />}
      <InlineTextInput
        {...props}
        id={name}
        value={value}
        onChange={onChange}
        decoratorTextProps={{
          ...props.decoratorTextProps,
        }}
        hasError={!!error}
      />
    </div>
  );
};
